import moment from 'moment';
import { compareValues } from '../../utilities/CommonUtilities';
import { SafeBridgeNewSearchTypesConstants } from './safe-bridge-types';

const SAFE_BRIDGE_AZURE_DATA = {
  lastSearchData: {},
  currentSearchData: {},
};

// function shiftArrayToRight(arr, places) {
//   for (let i = 0; i < places; i++) {
//     arr.unshift(arr.pop());
//   }
//   return arr;
// }

export const safeBridgeAzureSearchData = (
  state = SAFE_BRIDGE_AZURE_DATA,
  action
) => {
  switch (action.type) {
    case SafeBridgeNewSearchTypesConstants.SAFE_BRIDGE_AZURE_SEARCH:
      if (action.payload) {
        const payloadData = action.payload;

        const totalDocumentCount = action.payload['@odata.count'];
        const searchFacetsObject = payloadData['@search.facets'];

        let preparedSearchFacets = [];
        let preparedObject = {};
        let datePublished = {};

        if (searchFacetsObject) {
          datePublished = {
            startDate: moment('1975-03-04T10:57:02.444Z'),
            endDate: moment().toISOString(),
          };

          preparedSearchFacets = Object.keys(searchFacetsObject)
            .filter((e) => e !== 'DatePublished')
            .map((e) => {
              const value = searchFacetsObject[e].filter(
                (element) => element.value.length !== 0
              );
              return {
                key: e,
                value, // .sort(compareValues('count', 'desc'))
              };
            })
            .sort(compareValues('key', 'desc'));
        }

        preparedSearchFacets = preparedSearchFacets.sort(compareValues('key'));
        preparedObject = {
          ...preparedObject,
          ...action.payload,
          totalDocumentCount,
          preparedSearchFacets,
          datePublished,
        };
        return {
          ...state,
          currentSearchData: preparedObject,
        };
      }
      return {
        ...state,
      };

    case SafeBridgeNewSearchTypesConstants.LAST_SAFE_BRIDGE_SEARCH:
      if (action.payload) {
        return {
          ...state,
          lastSearchData: action.payload,
        };
      }
      return {
        ...state,
      };

    default:
      return state;
  }
};
